import { createAction } from 'redux-actions';
import types from '../types';

export const requestDeleteItem = createAction(types.OPEN_MODAL);
export const deleteItem = createAction(types.DELETE_REQUESTED);
export const cancel = createAction(types.CANCEL);
